import { ReactNode, memo } from 'react';

import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Box, Theme } from '@mui/material';

const pairSx = { display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0 } as const;

const getArrowSx = (theme: Theme) => ({
  fontSize: '0.875rem',
  color: theme.palette.grey[600],
  flexShrink: 0,
});

export interface CellPairProps {
  current: ReactNode;
  wanted?: ReactNode;
}

/** A grid cell showing a current value, and — once something is staged against it — the wanted value it would become, joined by an arrow. */
export const CellPair = memo(({ current, wanted }: CellPairProps) => (
  <Box sx={pairSx}>
    {current}
    {wanted != null && (
      <>
        <ArrowForwardRoundedIcon sx={getArrowSx} />
        {wanted}
      </>
    )}
  </Box>
));
CellPair.displayName = 'CellPair';
